/* Addlore botanicals section — logic only.
   20-09-2026: moved out of sections/adl-botanicals.liquid. It contained no Liquid, so it is a
   straight move. Loaded with `defer`, so it is parsed off the critical path and still runs
   before DOMContentLoaded — any DOMContentLoaded handler inside fires exactly as before. */

(function(){
  var SPEED=24;
  var DROP=['Ships in a plain silver pouch'];
  var ADD=[{todo:'a real review, first name, city'}];

  function ticker(){
    var bar=document.querySelector('.v3top');
    if(!bar||bar.dataset.adlTk) return;
    var track=bar.querySelector('div');
    if(!track) return;
    var msgs=[];
    [].forEach.call(track.querySelectorAll('span'),function(s){
      var t=(s.textContent||'').replace(/\s+/g,' ').trim().replace(/\s*[—–]\s*/g,', ');
      if(t&&msgs.indexOf(t)===-1&&DROP.indexOf(t)===-1) msgs.push(t);
    });
    msgs=msgs.concat(ADD);
    if(msgs.length<2) return;
    bar.dataset.adlTk='1';
    track.className='tk';
    while(track.firstChild) track.removeChild(track.firstChild);

    function buildRun(reps,hidden){
      var d=document.createElement('div');
      d.className='tk-run';
      if(hidden) d.setAttribute('aria-hidden','true');
      for(var r=0;r<reps;r++) msgs.forEach(function(m){
        var p=document.createElement('p'); p.className='tk-s';
        if(typeof m==='string'){ p.textContent=m; }
        else { var b=document.createElement('span'); b.className='tk-todo'; b.textContent=m.todo; p.appendChild(b); }
        d.appendChild(p);
      });
      return d;
    }

    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      track.appendChild(buildRun(1,false)); return;
    }
    var reps=1, run=buildRun(reps,false);
    track.appendChild(run);
    while(run.getBoundingClientRect().width<window.innerWidth&&reps<8){
      reps++; var wider=buildRun(reps,false); track.replaceChild(wider,run); run=wider;
    }
    var half=run.getBoundingClientRect().width;
    track.appendChild(buildRun(reps,true));
    track.style.setProperty('--tk-dur',Math.max(20,Math.round(half/SPEED))+'s');
  }

  /* overlay() kept for reference only -- not called. See the file
    header, "INGREDIENT OVERLAY -- REMOVED, 2 Sep 2026". */
  function overlay(){
    var CHEV='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
    var dlg=document.getElementById('v3dlg');
    var strip=document.querySelector('.v3ing');
    if(!dlg||!strip||dlg.dataset.adlNav) return;
    var tiles=[].slice.call(strip.querySelectorAll('button[data-ing]'));
    if(tiles.length<2) return;
    dlg.dataset.adlNav='1';

    /* never let a stuck overlay survive a refresh */
    if(dlg.open){ try{ dlg.close(); }catch(e){} }

    var well=dlg.querySelector('.top'), body=dlg.querySelector('.bd'), name=dlg.querySelector('#v3dName');
    if(!well||!body) return;

    var shot=document.createElement('div');
    shot.className='adl-shot';
    well.appendChild(shot);
    if(name) name.setAttribute('aria-live','polite');

    var nav=document.createElement('div'); nav.className='adl-nav';
    var prev=document.createElement('button'); prev.type='button'; prev.innerHTML=CHEV; prev.setAttribute('aria-label','Previous botanical');
    var next=document.createElement('button'); next.type='button'; next.innerHTML=CHEV; next.style.transform='scaleX(-1)'; next.setAttribute('aria-label','Next botanical');
    var rail=document.createElement('div'); rail.className='adl-rail'; rail.setAttribute('role','tablist');

    var thumbs=tiles.map(function(t,i){
      var b=document.createElement('b');
      b.style.backgroundImage='var(--adl-i'+i+')';
      b.setAttribute('role','tab'); b.setAttribute('tabindex','0');
      var nm=t.querySelector('.nm');
      b.setAttribute('aria-label', nm?nm.firstChild.textContent.trim():'Botanical '+(i+1));
      b.addEventListener('click',function(){ go(i); });
      b.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); go(i); } });
      rail.appendChild(b);
      return b;
    });

    nav.appendChild(prev); nav.appendChild(rail); nav.appendChild(next);
    dlg.appendChild(nav);

    var current=0, busy=false, timer=null, openedAt=0;

    function clearAnim(){ dlg.classList.remove('is-out','to-next','to-prev'); }
    function reset(){
      if(timer){ clearTimeout(timer); timer=null; }
      if(Object.prototype.hasOwnProperty.call(dlg,'showModal')) delete dlg.showModal;
      clearAnim(); busy=false;
    }
    function paint(i){
      current=i;
      dlg.setAttribute('data-ing',i);
      shot.style.backgroundImage='var(--adl-i'+i+')';
      thumbs.forEach(function(b,n){ b.setAttribute('aria-current', n===i?'true':'false'); });
    }

    var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function go(i){
      var n=tiles.length;
      i=((i%n)+n)%n;
      if(i===current||busy||!dlg.open) return;
      var forward=(i-current+n)%n===1||(i>current&&(current-i+n)%n!==1);
      busy=true;
      function swap(){
        timer=null;
        if(!dlg.open){ reset(); return; }
        var shadowed=false;
        if(dlg.open){ dlg.showModal=function(){}; shadowed=true; }
        try{ tiles[i].click(); } finally { if(shadowed) delete dlg.showModal; }
        paint(i); clearAnim(); busy=false;
      }
      if(reduced){ swap(); return; }
      dlg.classList.add('is-out', forward?'to-next':'to-prev');
      timer=setTimeout(swap,190);
    }

    prev.addEventListener('click',function(){ go(current-1); });
    next.addEventListener('click',function(){ go(current+1); });

    tiles.forEach(function(t,i){
      t.addEventListener('click',function(){
        openedAt=Date.now();
        if(!busy){ paint(i); clearAnim(); }
      },true);
    });

    dlg.addEventListener('keydown',function(e){
      if(e.key==='ArrowRight'){ e.preventDefault(); go(current+1); }
      else if(e.key==='ArrowLeft'){ e.preventDefault(); go(current-1); }
    });

    /* closing, independent of modal state */
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape'&&dlg.open){ e.preventDefault(); try{ dlg.close(); }catch(err){} }
    });
    document.addEventListener('pointerdown',function(e){
      if(!dlg.open) return;
      if(Date.now()-openedAt<300) return;
      if(dlg.contains(e.target)) return;
      try{ dlg.close(); }catch(err){}
    },true);

    dlg.addEventListener('close',reset);
    dlg.addEventListener('cancel',reset);

    var x0=null,y0=null;
    well.addEventListener('touchstart',function(e){ var t=e.changedTouches[0]; x0=t.clientX; y0=t.clientY; },{passive:true});
    well.addEventListener('touchend',function(e){
      if(x0===null) return;
      var t=e.changedTouches[0], dx=t.clientX-x0, dy=t.clientY-y0;
      x0=null;
      if(Math.abs(dx)>44&&Math.abs(dx)>Math.abs(dy)*1.6) go(current+(dx<0?1:-1));
    },{passive:true});

    var px=null;
    well.addEventListener('pointerdown',function(e){ if(e.pointerType==='mouse') px=e.clientX; });
    well.addEventListener('pointerup',function(e){
      if(px===null) return;
      var dx=e.clientX-px; px=null;
      if(Math.abs(dx)>56) go(current+(dx<0?1:-1));
    });

    paint(0);
  }

  function init(){ ticker(); /* overlay() removed 2 Sep -- see file header */ }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',init); }
  else { init(); }
})();

